import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Toolbar } from "devextreme-react";
import useGetProfilePicture from "../../Hooks/useGET/useGetProfilePictures";
import {
  getUsersName,
  getUserId,
  getUsersEmail,
  getUsersRoles,
  getUsersWorkCenter,
} from "../../Utils/helper";
import EditingPicturePopup from "./Components/editingPicture";
import "./styles.css";
import QRCode from "./Components/generateQRCode";
import VerificationCodeInput from "../../Components/VerificationCodeInput";
import {
  handlePostUserPin,
  handlePostCreateUserPin,
} from "../../Utils/handlePOST/handlePostUserPin";
import useFetch from "../../Hooks/useFetch";
import ActionNotifications from "../../Components/ActionNotifications";
import handlePostValidateUserPin from "../../Utils/handlePOST/handlePostValidateUserPin";
import { Item } from "devextreme-react/data-grid";
import useGetAllUsers from "../../Hooks/useGET/useGetAllUsers";

function DetailTile({ title, value }) {
  return (
    <div className="detail-tile">
      <div className="detail-tile-content">
        <div className="detail-tile-title">{title}</div>
        <div className="detail-tile-value">{value}</div>
      </div>
    </div>
  );
}
function initials(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() ?? "")
    .join("");
}
export default function ProfilePage() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const userId = getUserId();
  const userName = getUsersName();
  const nameParts = userName.split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts[1];

  const userEmail = getUsersEmail();
  const userWorkCenter = getUsersWorkCenter();
  const userRoles = getUsersRoles();
  const { userPicture, error, isLoading, mutate } =
    useGetProfilePicture(userId);
  const isDefaultImage = /blank\.jpg$/i.test(userPicture);
  // console.log("SHOWIMAGE => ", isDefaultImage);
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [isOldPinError, setIsOldPinError] = useState(false);
  const [isNewPinError, setIsNewPinError] = useState(false);
  const [pinResponseMessage, setPinResponseMessage] = useState(null);

  const { allUsers } = useGetAllUsers(),
    filteredUser = allUsers?.find((x) => x.label === getUsersName());

  const hasPinSet = filteredUser?.hasPinSet;

  const isValidPin = (pin) => /^\d{4}$/.test(pin); //validates the given input is a 4-digit numeric string

  // console.log(hasPinSet);
  // console.log(userId);

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    let hasError = false;
    setPinResponseMessage(null);

    if (hasPinSet) {
      // if hasPinSet = true
      if (!isValidPin(oldPin)) {
        setIsOldPinError(true);
        hasError = true;
      } else {
        setIsOldPinError(false);
      }
    } else {
      // if hasPinSet = false
      if (!isValidPin(newPin)) {
        setIsNewPinError(true);
        hasError = true;
      } else {
        setIsNewPinError(false);
      }
    }
    if (hasError) return;
    if (hasPinSet && oldPin === newPin) {
      setIsNewPinError(true);
      setPinResponseMessage({
        success: false,
        data: {
          statusCode: false,
          messeges: ["New Pin cannot be the same as the old pin"],
        },
      });
      return;
    }
    try {
      // if every pin is good submit
      if (hasPinSet) {
        // console.log("Resetting the old pin", { userId, oldPin, newPin });
        const { response, isDataGood } = await handlePostUserPin(
          userId,
          oldPin,
          newPin,
          fetch,
        );
        // console.log("Page reset =>", response.data.messeges);
        setPinResponseMessage(response);
        setNewPin("");
        setOldPin("");
      } else {
        // console.log("Creating new pin", newPin);
        const { response, isDataGood } = await handlePostCreateUserPin(
          userId,
          newPin,
          fetch,
        );
        // console.log("Page create =>", response.data?.messeges);
        setPinResponseMessage(response);
      }
    } catch (error) {
      // console.log("PIN submit failed", error);
      setPinResponseMessage({
        success: false,
        data: {
          statusCode: false,
          messeges: ["PIN submit failed"],
        },
        errors: error,
      });
    }
  };
  // console.log(userPicture);
  const renderGrid = () => {
    return (
      <div className="px-lg-4 content">
        <div className="px-2 page-content">
          <div className="contentBox my-3">
            <header className="profile-header">
              <Toolbar>
                <Item
                  location="before"
                  locateInMenu="never"
                  render={() => (
                    <div>
                      <h1 className="white">My Profile</h1>
                    </div>
                  )}
                />
              </Toolbar>
            </header>
            {/*lefft panel*/}
            <div className="profile-panels">
              <div className="profile-container mt-3">
                <div className="profile-image-wrapper">
                  {isDefaultImage ? (
                    <div className="profile-avatar">{initials(userName)}</div>
                  ) : (
                    <img
                      className="profile-image"
                      src={userPicture}
                      alt={userName || "Employee"}
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  )}
                </div>
                <div>
                  {isDefaultImage && (
                    <Button
                      text="Edit Photo"
                      type="outlined"
                      stylingMode="contained"
                      onClick={() => setIsEditPopupOpen(true)}
                    />
                  )}
                </div>
              </div>
              {/*right panel*/}
              <div className="profile-info">
                <div className="profile-name">
                  <DetailTile title="First Name" value={firstName} />
                  <DetailTile title="Last Name" value={lastName} />
                </div>
                <DetailTile title="Email" value={userEmail} />
                <DetailTile title="Work Center" value={userWorkCenter.name} />
                <DetailTile
                  title="Roles"
                  value={
                    <div
                      style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                      {userRoles.map((role, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: "#818181",
                            color: "#ffffff",
                            padding: "4px 12px",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                        >
                          {role}
                        </span>
                      ))}
                    </div>
                  }
                />
              </div>
            </div>
            <EditingPicturePopup
              visible={isEditPopupOpen}
              userId={userId}
              onClose={() => setIsEditPopupOpen(false)}
              onSaved={async () => {
                await mutate();
                setIsEditPopupOpen(false);
              }}
              error={error}
            />
          </div>

          <div className="profile-panels contentBox manage-user">
            <h1>Manage User</h1>
            <div className=" my-3 qr-code-tile tile">
              {/*left panel*/}
              <QRCode userId={userId} />
            </div>
            {/*right panel*/}

            <div className=" my-3 reset-pin-tile tile">
              <h3 className="white">Reset pin</h3>
              {hasPinSet && (
                <div style={{ marginBottom: "10px" }}>
                  <p className="gray">Enter Old Pin</p>
                  <VerificationCodeInput
                    length={4}
                    value={oldPin}
                    onChange={(value) => {
                      setOldPin(value);
                      if (isOldPinError) setIsOldPinError(false);
                    }}
                    isError={isOldPinError}
                  />
                </div>
              )}
              <div style={{ marginBottom: "10px" }}>
                <p className="gray">
                  {hasPinSet ? "Enter New Pin" : "Create New Pin"}
                </p>
                <VerificationCodeInput
                  length={4}
                  value={newPin}
                  onChange={(value) => {
                    setNewPin(value);
                    if (isNewPinError) setIsNewPinError(false);
                  }}
                  isError={isNewPinError}
                />
              </div>
              <div
                style={{
                  color: "gray",
                  marginTop: "8px",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                Please enter a 4-digit PIN
              </div>
              <div className="reset-button">
                <Button
                  type="outlined"
                  text={hasPinSet ? "Reset Pin" : "Set Pin"}
                  onClick={handleSubmit}
                  style={{ marginTop: "12px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <ActionNotifications response={pinResponseMessage} />
      {renderGrid()}
    </div>
  );
}
